import React, { Component } from 'react';
import { Row, Col, ProgressBar, Alert, Image, Label } from 'react-bootstrap';
import update from 'immutability-helper';
import { i18n } from '../../../services/globalize';

const uploadStatus = {
	success: 1,
	error: 2
};

class FileListener extends Component {

	constructor(props) {
		super(props);
		this.createState();
		this.onStatusChange = this.onStatusChange.bind(this);
		this.onProgress = this.onProgress.bind(this);
		this.onComplete = this.onComplete.bind(this);
		this.onError = this.onError.bind(this);
	}

	componentDidMount() {
		this.props.uploader.on('statusChange', this.onStatusChange);
		this.props.uploader.on('progress', this.onProgress);
		this.props.uploader.on('complete', this.onComplete);
		this.props.uploader.on('error', this.onError);
	}

	componentWillReceiveProps(nextProps) {
		const initialData = nextProps.initialData;
		if (!this.state.didSetInitialData && initialData) {
			this.setState(update(this.state, {
				didSetInitialData: { $set: true },
				submittedFile: { filename: { $set: initialData.filename }, url: { $set: initialData.url } }
			}));
		}
	}

	createState() {
		const initialData = this.props.initialData;
		// Called only from the constructor, so this is initialisation rather than a mutation
		// of mounted state - ESLint cannot see the call site.
		// eslint-disable-next-line react/no-direct-mutation-state
		this.state = {
			didSetInitialData: !!initialData,
			submittedFile: {
				filename: initialData ? initialData.filename : 'undefined',
				url: initialData ? initialData.url : 'undefined',
			}
		}
	}

	componentWillUnmount() {
		this.props.uploader.off('statusChange', this.onStatusChange);
		this.props.uploader.off('progress', this.onProgress);
		this.props.uploader.off('complete', this.onComplete);
		this.props.uploader.off('error', this.onError);
	}

	onProgress(id, name, uploadedBytes, totalBytes) {
		this.setState(update(this.state, {
			submittedFile: { $merge: { now: uploadedBytes, max: totalBytes } }
		}));
	}

	onComplete(id, name, response) {
		const { success, url, files, fileId } = response;
		if (!success) {
			this.setState(update(this.state, {
				submittedFile: { $merge: { fromServer: true, status: uploadStatus.error, error: response.message } }
			}));
			return;
		}

		const onChange = this.props.input.onChange;
		if (onChange) {
			onChange(fileId);
		}

		this.setState(update(this.state, {
			submittedFile: { $merge: { url, filename: files[0].name } }
		}));
	}

	onError(id, name, errorReason) {
		this.setState(update(this.state, {
			submittedFile: { $merge: { fromServer: true, status: uploadStatus.error, error: errorReason } }
		}));
	}

	onStatusChange(id, oldStatus, status) {
		const statusEnum = this.props.uploader.qq.status;
		if (status === statusEnum.SUBMITTING) {
			this.setState(update(this.state, {
				submittedFile: { $set: { id, } }
			}));
		} else if (status === statusEnum.UPLOAD_SUCCESSFUL) {
			this.setState(update(this.state, {
				submittedFile: { $merge: { fromServer: true, status: uploadStatus.success } }
			}));
		}
	}

	renderComonStatusBlock(style, status, text) {
		return (
			<Row >
				<Col sm={4}>
					<Alert bsStyle={style}>
						<strong>{status}</strong> {text}
					</Alert>
				</Col>
			</Row>
		);
	}

	renderStatusBlock(status, error) {
		if (!status) {
			return null;
		}

		const statusText = status === uploadStatus.success ? i18n.t('FileUpload_Success') : i18n.t('FileUpload_Failed');
		const statusStyle = status === uploadStatus.success ? 'success' : 'danger';
		return this.renderComonStatusBlock(statusStyle, statusText, error);
	}

	renderProgressBar(now, max) {
		return now != max &&
			<Row>
				<Col sm={4}>
					<ProgressBar
						active
						now={now}
						max={max} />
				</Col>
			</Row>;
	}

	renderFileDescr(input, image) {
		if (!input || !input.value) {
			return null;
		}

		let fileDescr;
		if (image) {
			fileDescr = <Image src={this.state.submittedFile.url} thumbnail responsive />;
		} else {
			fileDescr = <h4><a target='blank' href={this.state.submittedFile.url}>{this.state.submittedFile.filename}</a></h4>;
		}

		return (
			<Row>
				<Col sm={4}>
					<div>{fileDescr}</div>
				</Col>
			</Row>
		);
	}

	clear() {
		this.setState(update(this.state, {
			submittedFile: { $set: {} }
		}));
	}

	render() {
		const { status, now, max, error } = this.state.submittedFile;
		const { image, input } = this.props;
		const statusBlock = this.renderStatusBlock(status, error);
		const progressBar = this.renderProgressBar(now, max);
		const fileDescription = this.renderFileDescr(input, image);
		return (
			<div>
				{fileDescription}
				{progressBar}
				{statusBlock}
			</div>
		);
	}
}

export default FileListener;